var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('svg',{staticClass:"svg",attrs:{"viewBox":"0 0 160 90","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M40,0 h7 C 37 45, 51 80, 58 90 h-18 z"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }